import { CORE_FEATURE_KEY } from '../../constants/state-keys';
import { CoreCombinedReducersInterface } from './core-combined-reducers-states.interface';

export interface CoreState {
    [CORE_FEATURE_KEY]: CoreCombinedReducersInterface;
}
